export default __webpack_public_path__ + "images/4fe8a2b4c605e4ee1a668ea5b6d3418e.png";